<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container
  class="mainWrapper blue_theme"
  autosize
  autoFocus
  dir="ltr"
>
  <router-outlet></router-outlet>
</mat-sidenav-container>
